import { VuexModule, Module, Mutation, Action } from 'vuex-module-decorators'
import IUserInfo from '@/types/IUserInfo';

@Module({namespaced: true, name: 'user'})
export default class User extends VuexModule {
  permissions: string[] = [];
  companyId: number = 0;
  companyName: string = '';
  firstName: string = '';
  id: number = 0;
  lastName: string = '';
  mail: string = '';
  role: string = '';

  isLoggedAs: boolean = false;
  // peopleId: string;

  @Mutation
  setUser(newUser: IUserInfo): void {
    this.permissions = newUser.permissions
    this.companyId = newUser.companyId
    this.companyName = newUser.companyName
    this.firstName = newUser.firstName
    this.id = newUser.id
    this.lastName = newUser.lastName
    this.mail = newUser.mail
    this.role = newUser.role
  }

  @Mutation
  setIsLoggedAs(isLoggedAs: boolean): void {
    this.isLoggedAs = isLoggedAs
  }

  get fullName() {
    return `${this.firstName} ${this.lastName}`
  }

  get getPermissions() {
    return this.permissions
  }
  // @Action
  // setUser(newUser: IUserInfo): void {
  //   this.context.commit('setUser', newUser)
  // }
}
